const intSize = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
}
const size = {
  xs: intSize.xs + 'px',
  sm: intSize.sm + 'px',
  md: intSize.md + 'px',
  lg: intSize.lg + 'px',
  xl: intSize.xl + 'px',
  xxl: intSize.xxl + 'px',
}

const inputBg = '#FFFFFF'
const lightGray = '#F0F2F5'
const gray = '#D9D9D9'
const darkGray = '#CBCBCB'
const lightBlack = '#5F5E5E'
const secondaryDarkGray = '#939393'
const scrapBlue = '#355891'
const scrapBlueShadow = '#55d9fe22'
const primaryColor = scrapBlue
const statusGreen = '#90e570'
const statusYellow = '#f3e778'
const statusRed = '#ec7684'
const green = '#3DD78D'
const greenHover = '#39CA84'
const red = '#E1394D'
const redHover = '#D12D40'
const blue = '#4A39E1'
const blueHover = '#4030D2'
const redCardCanceled = '#FFE5E5'
const textColor = '#495057'
const white = '#FFFFFF'
const detailModalBg = '#eaf5ff'
const rowHover = '#96bdfc65'
const statusTicketColor = {
  CREATED: '#FF9533',
  PENDING: '#FFF832',
  CONFIRMED: '#9DFF7A',
  TRANSIT: '#9DFF7A',
  INVOICED: lightGray,
  CANCELED: lightGray,
  DELIVERED: lightGray,
  AWAITING: lightGray,
  RELEASED: lightGray,
  SUPPLIER_INVOICED: lightGray,
  REQUEST: lightGray,
  APPROVED: lightGray,
  NO_SHOW: lightGray,
  DECLINED: lightGray,
}
const carrierTableColors = {
  PENDING: `${statusTicketColor.PENDING}50`,
  CONFIRMED: `${statusTicketColor.CONFIRMED}50`,
  SELECTED_EQUIPMENT_COLUMN: `${scrapBlue}20`,
}

const theme = {
  xs: `(max-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  '@primary-color': primaryColor,
  '@input-bg': inputBg,
  '@border-radius-base': '2px',
  '@table-header-bg': 'white',
  '@divider-color': 'black',
  primaryColor,
  inputBg,
  lightGray,
  gray,
  darkGray,
  lightBlack,
  secondaryDarkGray,
  red,
  redHover,
  green,
  greenHover,
  detailModalBg,
  blue,
  blueHover,
  scrapBlue,
  scrapBlueShadow,
  statusRed,
  textColor,
  redCardCanceled,
  rowHover: rowHover,
  black: 'black',
  status: {
    green: statusGreen,
    yellow: statusYellow,
    red: statusRed,
  },
  size,
  white,
  statusTicketColor,
  carrierTableColors,
  intSize,
}

module.exports = { theme }
